module.exports = __webpack_public_path__ + "img/varoszoba_enterior_3.a9f70734.jpg";